module.exports = __webpack_public_path__ + "static/media/detail_0039_t.21c37220.jpg";